import { Injectable, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { UserLanguage } from '../services/repositories/api-repository';

const LANGUAGE_STORAGE_KEY = 'rd.language';

@Injectable({ providedIn: 'root' })
export class I18nService {
  private readonly translate = inject(TranslateService);
  private readonly supportedLanguages: UserLanguage[] = ['en', 'fr'];

  init(): void {
    this.translate.addLangs(this.supportedLanguages);
    this.translate.setDefaultLang('en');

    // Persisted preference wins on app restart so shell/login/profile stay in the same language.
    const persisted = this.getPersistedLanguage();
    this.useLanguage(persisted ?? 'en');
  }

  useLanguage(language: UserLanguage): void {
    this.translate.use(language);
    localStorage.setItem(LANGUAGE_STORAGE_KEY, language);
  }

  getPersistedLanguage(): UserLanguage | null {
    const value = localStorage.getItem(LANGUAGE_STORAGE_KEY);
    return value === 'fr' || value === 'en' ? value : null;
  }
}
